import React, { useState } from 'react';
import { Card } from 'react-bootstrap';

const Tile = ({ 
  title, 
  description, 
  onClick, 
  icon,
  gradient = 'blue',
  className = ''
}) => {
  const [isHovered, setIsHovered] = useState(false);
  
  const baseShadow = '0 5px 15px rgba(102, 126, 234, 0.3)';
  const hoverShadow = '0 8px 25px rgba(102, 126, 234, 0.5)';

  const gradients = {
    blue: {
      base: 'linear-gradient(135deg, var(--bs-primary) 0%, #0056b3 100%)',
      hover: 'linear-gradient(135deg, #0056b3 0%, var(--bs-primary) 100%)'
    },
    pink: {
      base: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
      hover: 'linear-gradient(135deg, #f5576c 0%, #f093fb 100%)'
    },
    purple: {
      base: 'linear-gradient(135deg, #21D4FD 0%, #B721FF 100%)',
      hover: 'linear-gradient(135deg, #B721FF 0%, #21D4FD 100%)'
    },
    green: {
      base: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
      hover: 'linear-gradient(135deg, #38f9d7 0%, #43e97b 100%)'
    }
  };

  const selectedGradient = gradients[gradient] || gradients.blue;

  const tileCardStyle = {
    position: 'relative',
    borderRadius: '1.5rem',
    transition: 'box-shadow 0.3s ease',
    cursor: 'pointer',
    background: selectedGradient.base,
    border: 'none',
    color: '#fff',
    boxShadow: isHovered ? hoverShadow : baseShadow,
    overflow: 'hidden',
  };

  const overlayStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: selectedGradient.hover,
    opacity: isHovered ? 1 : 0,
    transition: 'opacity 0.6s ease',
    borderRadius: '1.5rem',
    pointerEvents: 'none',
  };

  const contentStyle = {
    position: 'relative',
    zIndex: 1,
  };

  const tileIconStyle = {
    fontSize: '2.5rem',
    color: '#fff',
  };
  
  return (
    <Card
      className={`text-center shadow-sm h-100 ${className}`}
      style={tileCardStyle}
      onClick={onClick}
      role="button"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div style={overlayStyle} />
      <Card.Body className="d-flex flex-column align-items-center justify-content-center p-4" style={contentStyle}>
        {icon && <div style={tileIconStyle} className="mb-3">{icon}</div>}
        <Card.Title className="fs-5 fw-bold mb-2">{title}</Card.Title>
        <Card.Text className="small opacity-90">{description}</Card.Text>
      </Card.Body>
    </Card>
  );
};

export default Tile;